import { LogoDefinition } from '../types';

export const brandIconNegative: LogoDefinition = {
  id: 'brandIconNegative',
  width: 177,
  height: 177,
  svgContent: [
    {
      type: 'path',
      fill: '#0445a5',
      data: 'M177.074 -0.0380859H0.0742188V176.962H177.074V-0.0380859Z',
    },
    {
      type: 'path',
      fill: '#ffb800',
      data: 'M88.7573 71.7567C93.579 71.7571 98.2925 70.3277 102.302 67.6492C106.311 64.9707 109.436 61.1634 111.281 56.7089C113.127 52.2544 113.61 47.3526 112.669 42.6236C111.729 37.8945 109.407 33.5505 105.998 30.1409C102.589 26.7314 98.2449 24.4094 93.5159 23.4686C88.7869 22.5278 83.8851 23.0104 79.4305 24.8555C74.9758 26.7006 71.1683 29.8252 68.4895 33.8343C65.8107 37.8433 64.3809 42.5567 64.3809 47.3784C64.3809 53.8436 66.949 60.044 71.5204 64.6158C76.0919 69.1876 82.2921 71.7562 88.7573 71.7567Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M129.51 77.3135H105.056L88.8307 99.0183L72.5298 77.3135H48L76.5686 115.251L48 153.34H72.5298L88.8307 131.552L105.056 153.34H129.51L101.019 115.251L129.51 77.3135Z',
    },
  ],
};
